// src/components/MiniMonthBar.js
import React from "react";
import {
  addMonths, subMonths, isSameMonth, format,
  startOfWeek, addDays, getISOWeek, subWeeks, addWeeks, subDays
} from "date-fns";

export default function MiniMonthBar({
  mode, setMode,
  availableYears = [],
  year, setYear,
  month, setMonth,
  week, setWeek,
  day, setDay
}) {
  // สำหรับ month picker
  const months = [
    subMonths(month, 1),
    month,
    addMonths(month, 1),
  ];
  // สำหรับ week picker
  const weekStart = startOfWeek(week, { weekStartsOn: 1 });
  const weekEnd = addDays(weekStart, 6);

  return (
    <div className="flex flex-col gap-2 mb-6 sticky top-0 z-20 bg-white pt-2">
      {/* View Switcher */}
      <div className="flex justify-center gap-2">
        {["Day", "Week", "Month", "Year"].map(view => (
          <button
            key={view}
            className={`px-3 py-1 rounded-full font-semibold transition ${mode === view.toLowerCase()
              ? "bg-indigo-500 text-white"
              : "bg-gray-100 text-gray-700 hover:bg-indigo-100"}`}
            onClick={() => setMode(view.toLowerCase())}
          >{view}</button>
        ))}
        {/* Year Picker */}
        {mode === "year" && (
          <select
            className="ml-3 px-2 py-1 rounded border"
            value={year}
            onChange={e => setYear(Number(e.target.value))}
          >
            {availableYears.map(yr =>
              <option key={yr} value={yr}>{yr}</option>
            )}
          </select>
        )}
      </div>

      {/* Month MiniBar */}
      {mode === "month" && (
        <div className="flex justify-center items-center gap-3 mt-1">
          <button
            onClick={() => setMonth(subMonths(month, 1))}
            className="text-xl px-2"
            aria-label="Previous month"
          >‹</button>
          {months.map((m, i) => (
            <button
              key={i}
              className={
                "px-4 py-2 rounded-full font-semibold transition " +
                (isSameMonth(m, month)
                  ? "bg-indigo-500 text-white scale-105 shadow"
                  : "bg-gray-100 text-gray-700 hover:bg-indigo-100")
              }
              onClick={() => setMonth(m)}
            >
              {format(m, "MMM yyyy")}
            </button>
          ))}
          <button
            onClick={() => setMonth(addMonths(month, 1))}
            className="text-xl px-2"
            aria-label="Next month"
          >›</button>
        </div>
      )}

      {/* Week MiniBar */}
      {mode === "week" && (
        <div className="flex justify-center items-center gap-2 mt-1">
          <button
            onClick={() => setWeek(subWeeks(week, 1))}
            className="text-xl px-2"
            aria-label="Previous week"
          >‹</button>
          <span className="px-4 py-2 rounded-full bg-indigo-500 text-white font-semibold">
            Week {getISOWeek(week)} ({format(weekStart, "dd MMM")}-{format(weekEnd, "dd MMM")})
          </span>
          <button
            onClick={() => setWeek(addWeeks(week, 1))}
            className="text-xl px-2"
            aria-label="Next week"
          >›</button>
        </div>
      )}

      {/* Day Picker */}
      {mode === "day" && (
        <div className="flex justify-center items-center gap-2 mt-1">
          <button
            onClick={() => setDay(subDays(day, 1))}
            className="text-xl px-2"
            aria-label="Previous day"
          >‹</button>
          <input
            type="date"
            value={format(day, "yyyy-MM-dd")}
            onChange={e => setDay(new Date(e.target.value))}
            className="border rounded px-3 py-1"
            style={{ width: 140 }}
          />
          <button
            onClick={() => setDay(addDays(day, 1))}
            className="text-xl px-2"
            aria-label="Next day"
          >›</button>
        </div>
      )}
    </div>
  );
}